import { render, staticRenderFns } from "./PurchaseSticky.vue?vue&type=template&id=4560ac6c"
import script from "./PurchaseSticky.vue?vue&type=script&lang=js"
export * from "./PurchaseSticky.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSticky.vue?vue&type=style&index=0&id=4560ac6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports